'use es6';

import { ENUMERATION } from 'customer-data-objects/property/PropertyTypes';
export default {
  hs_parent_company_id: {
    inputType: ENUMERATION
  }
};